import React from "react";
import { ConfirmPropsType } from "./types";
import "./Confirm.scss";
import "./i18n";
import { useTranslation } from "react-i18next";

const Confirm: React.FC<ConfirmPropsType> = ({
  testId,
  optionNoClicked,
  optionYesClicked,
  question,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="confirm-container" data-testId={testId} id={testId}>
      <p
        className="confirm-question"
        id={`${testId}-question`}
        data-testId={`${testId}-question`}
      >
        {question}
      </p>
      <p
        className="confirm-option"
        id={`${testId}-yes`}
        data-testId={`${testId}-yes`}
        onClick={optionYesClicked}
      >
        {t("confirm:yes")}
      </p>
      <p
        className="confirm-option"
        id={`${testId}-no`}
        data-testId={`${testId}-no`}
        onClick={optionNoClicked}
      >
        {t("confirm:no")}
      </p>
    </div>
  );
};

export default Confirm;
